'use strict';

(function() {
	angular.module('onboarding.common.security')
		.directive('cobSessionState', cobSessionState);

	cobSessionState.$inject = ['$log', 'sessionService', 'subjectObserverMessagesService', 'observerService'];

	var log, sessionService, subjectObserverMessagesService, observerService, observerMessages;

	function cobSessionState(_$log_, _sessionService_, _subjectObserverMessagesService_, _observerService_) {

		sessionService = _sessionService_;
		log = _$log_;
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;

		return {
			restrict: 'E',
			scope: {},
			replace: true,
			templateUrl: '/app/common/security/sessionState.html',
			link: linkFunction
		};

	}

	function linkFunction(scope) {
		activate();

		function activate() {
			observerMessages = subjectObserverMessagesService.getObserverMessages();
			registerObserverHandlers();

			if (!scope.userName)
				onSetup();
		}

		function onSetup() {
			scope.userName = sessionService.getUserName();
			scope.capabilities = sessionService.getCapabilities();
			log.debug('User:  ' + sessionService.userName);
		}

		function onLogoff() {
			scope.userName = '';
			scope.capabilities = [];
		}

		function registerObserverHandlers() {
			observerService.registerHandlers(scope,
				[
					{ message: observerMessages.COB_OBSERVER_LOGIN_FINISHED_SUCCESS, handler: onSetup },
					{ message: observerMessages.COB_OBSERVER_LOGOFF, handler: onLogoff }
				]);
		}


	}

})();
